/**
     * @desc 可配置文案
会根据Accept-Language判断查询的文案语言，如确定需查询其他语言，可以传递参数language参数，如"language=zh"。仅会产生统一错误码
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 会议号 */
  meetingId?: string;
  /** 文案类型，传递0查询所有类型，参考枚举 FeedbackDocType */
  type?: number;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/api/bs-vmeeting/web/v3/feedback/{meetingId}/doc',
      params,
      'GET',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/web/v3/feedback/{meetingId}/doc',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl(
      '/api/bs-vmeeting/web/v3/feedback/{meetingId}/doc',
      params,
      'GET',
    ),
    {
      method: 'GET',

      ...options,
    },
  );
}
